<template>
    <!--    <form ref="form" @submit.prevent>-->
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">예약시간 설정</span>
            <span class="txt">
                센터의 수업시간 시작설정 및 회원예약 어플리케이션(App)에서 회원이 수업을 예약, 취소하는 시간을 설정할 수
                있습니다. 또한, 강사의 수업 예약시간 제한설정이 가능합니다.
            </span>
        </div>

        <div class="com-tab">
            <router-link :to="{ name: 'SettingReservationTime' }">수업시간</router-link>
            <router-link :to="{ name: 'SettingReservationApp' }" class="on">회원예약 앱</router-link>
            <router-link :to="{ name: 'SettingReservationTeacher' }">강사수업 예약</router-link>
        </div>

        <p class="sub-title small">
            <strong>회원 예약시간 제한설정</strong>
            센터에서 진행하는 개인, 듀엣, OT 의 수업시작시간과 수업시간의 단위에 대한 시간표현을 설정합니다.
        </p>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <span class="top-title">
                        예약 가능 시간
                        <small>회원이 시작시간으로부터 얼마 전까지 예약이 가능한지 설정합니다.</small>
                    </span>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">개인 / OT</strong>
                                는 시작시간
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerReservationOtDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerReservationOtHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerReservationOtMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">예약</span>
                                이 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">그룹</strong>
                                은 시작시간
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerReservationGrDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerReservationGrHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerReservationGrMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">예약</span>
                                이 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">쿠폰</strong>
                                은 시작시간
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerReservationCpDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerReservationCpHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerReservationCpMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">예약</span>
                                이 가능합니다.
                            </span>
                        </div>
                    </div>
                    <span class="top-title">
                        취소 가능 시간
                        <small>회원이 시작시간으로부터 얼마 전까지 취소가 가능한지 설정합니다.</small>
                    </span>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">개인 / OT</strong>
                                는 시작시간
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerCancelOtDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerCancelOtHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerCancelOtMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">취소</span>
                                가 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">그룹</strong>
                                은 시작시간
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerCancelGrDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerCancelGrHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerCancelGrMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">취소</span>
                                가 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">쿠폰</strong>
                                은 시작시간
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerCancelCpDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerCancelCpHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerCancelCpMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">취소</span>
                                가 가능합니다.
                            </span>
                        </div>
                    </div>
                    <span class="top-title">
                        사전예약 가능 기한
                        <small>
                            회원이 사전예약할 수 있는 미래일자로 만약 7일을 설정했을 경우, 오늘 +7일 이후까지 있는
                            시간을 미리 예약할수 있습니다.
                        </small>
                    </span>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w80">
                                <strong class="blue">개인 / OT</strong>
                                는
                            </span>

                            <div class="com-radio">
                                <input
                                    id="radio-1-1"
                                    v-model="data.customerPreOtTypeCd"
                                    value="S"
                                    name="radio-1"
                                    required
                                    type="radio"
                                />
                                <label for="radio-1-1"></label>
                            </div>

                            <select-form
                                :disabled="data.customerPreOtTypeCd !== 'S'"
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerPreOt"
                                class="w150"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                일 이후까지
                                <span class="red">사전예약</span>
                                이 가능합니다.
                            </span>

                            <div class="com-radio">
                                <input
                                    id="radio-2-1"
                                    v-model="data.customerPreOtTypeCd"
                                    value="U"
                                    name="radio-1"
                                    required
                                    type="radio"
                                />
                                <label for="radio-2-1"></label>
                            </div>

                            <single-calendar
                                :disabledBeforeToday="true"
                                :date="data.customerPreOtDateDay"
                                :disabled="data.customerPreOtTypeCd !== 'U'"
                                class="w180"
                                @update="
                                    (v) => {
                                        data.customerPreOtDateDay = v;
                                        this.$nextTick(() => this.$forceUpdate());
                                    }
                                "
                            />

                            <span class="txt">
                                일까지
                                <span class="red">사전예약</span>
                                이 가능하며,
                            </span>
                            <input :value="data.customerPreOtDateDay" class="w100 center" readonly type="text" />
                            <span class="txt"></span>
                            <select-form
                                :disabled="data.customerPreOtTypeCd !== 'U'"
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerPreOtDateHour"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">:</span>
                            <select-form
                                :disabled="data.customerPreOtTypeCd !== 'U'"
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerPreOtDateMinute"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">에 자동으로</span>
                            <select-form
                                :disabled="data.customerPreOtTypeCd !== 'U'"
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerPreOtDays"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일 연장됩니다.</span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w80">
                                <strong class="blue">그룹</strong>
                                은
                            </span>

                            <div class="com-radio">
                                <input
                                    id="radio-3-1"
                                    v-model="data.customerPreGrTypeCd"
                                    value="S"
                                    name="radio-2"
                                    required
                                    type="radio"
                                />
                                <label for="radio-3-1"></label>
                            </div>
                            <select-form
                                :disabled="data.customerPreGrTypeCd !== 'S'"
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerPreGr"
                                class="w150"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                일 이후까지
                                <span class="red">사전예약</span>
                                이 가능합니다.
                            </span>

                            <div class="com-radio">
                                <input
                                    id="radio-3-2"
                                    v-model="data.customerPreGrTypeCd"
                                    value="U"
                                    name="radio-2"
                                    required
                                    type="radio"
                                />
                                <label for="radio-3-2"></label>
                            </div>

                            <single-calendar
                                :disabledBeforeToday="true"
                                :disabled="data.customerPreGrTypeCd !== 'U'"
                                :date="data.customerPreGrDateDay"
                                class="w180"
                                @update="
                                    (v) => {
                                        data.customerPreGrDateDay = v;
                                        this.$nextTick(() => this.$forceUpdate());
                                    }
                                "
                            />
                            <span class="txt">
                                일까지
                                <span class="red">사전예약</span>
                                이 가능하며,
                            </span>
                            <input :value="data.customerPreGrDateDay" class="w100 center" readonly type="text" />
                            <span class="txt"></span>
                            <select-form
                                :disabled="data.customerPreGrTypeCd !== 'U'"
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerPreGrDateHour"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">:</span>
                            <select-form
                                :disabled="data.customerPreGrTypeCd !== 'U'"
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerPreGrDateMinute"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">에 자동으로</span>
                            <select-form
                                :disabled="data.customerPreGrTypeCd !== 'U'"
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerPreGrDays"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일 연장됩니다.</span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w80">
                                <strong class="blue">쿠폰</strong>
                                은
                            </span>
                            <div class="com-radio">
                                <input
                                    id="radio-4-1"
                                    v-model="data.customerPreCpTypeCd"
                                    value="S"
                                    name="radio-3"
                                    required
                                    type="radio"
                                />
                                <label for="radio-4-1"></label>
                            </div>
                            <select-form
                                :disabled="data.customerPreCpTypeCd !== 'S'"
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerPreCp"
                                class="w150"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                일 이후까지
                                <span class="red">사전예약</span>
                                이 가능합니다.
                            </span>

                            <div class="com-radio">
                                <input
                                    id="radio-4-2"
                                    v-model="data.customerPreCpTypeCd"
                                    value="U"
                                    name="radio-3"
                                    required
                                    type="radio"
                                />
                                <label for="radio-4-2"></label>
                            </div>

                            <single-calendar
                                :disabledBeforeToday="true"
                                :disabled="data.customerPreCpTypeCd !== 'U'"
                                :date="data.customerPreCpDateDay"
                                class="w180"
                                @update="
                                    (v) => {
                                        data.customerPreCpDateDay = v;
                                        this.$nextTick(() => this.$forceUpdate());
                                    }
                                "
                            />
                            <span class="txt">
                                일까지
                                <span class="red">사전예약</span>
                                이 가능하며,
                            </span>
                            <input :value="data.customerPreCpDateDay" class="w100 center" readonly type="text" />
                            <span class="txt"></span>
                            <select-form
                                :disabled="data.customerPreCpTypeCd !== 'U'"
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.customerPreCpDateHour"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">:</span>
                            <select-form
                                :disabled="data.customerPreCpTypeCd !== 'U'"
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.customerPreCpDateMinute"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">에 자동으로</span>
                            <select-form
                                :disabled="data.customerPreCpTypeCd !== 'U'"
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.customerPreCpDays"
                                class="w80"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일 연장됩니다.</span>
                        </div>
                    </div>
                    <span class="top-title">
                        수업 오픈 시간 기준 설정
                        <div class="com-tooltip">
                            <button class="icon"></button>
                            <div class="detail" style="width: 410px">
                                <span class="tit">수업 오픈 시간 기준 설정</span>
                                <p class="txt">
                                    예약 가능 마지막날의 수업 오픈 기준을 설정 합니다.
                                    <br />
                                    예) 사전 예약 가능 기한 7일 기준
                                    <br />
                                    수업 시간 기준 - 다음주 월요일 10시 수업은 월요일 10시에 예약 가능합니다.
                                    <br />
                                    수업 일자 기준 - 다음주 월요일 수업은 월요일 자정에 모두 오픈됩니다.
                                </p>
                            </div>
                        </div>
                    </span>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <div class="com-radio">
                                    <input
                                        id="lessOpenTypeCdT"
                                        name="lessOpenTypeCdT"
                                        type="radio"
                                        value="T"
                                        v-model="data.lessOpenTypeCd"
                                    />
                                    <label for="lessOpenTypeCdT">수업 시간 기준</label>
                                </div>
                            </span>
                            <span class="txt w120">
                                <div class="com-radio">
                                    <input
                                        id="lessOpenTypeCdD"
                                        name="lessOpenTypeCdD"
                                        type="radio"
                                        value="D"
                                        v-model="data.lessOpenTypeCd"
                                    />
                                    <label for="lessOpenTypeCdD">수업 일자 기준</label>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="bottom-btn">
            <button class="com-btn blue" type="submit" @click="save">저장</button>
        </div>
    </div>
    <!--    </form>-->
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import moment from 'moment';

export default {
    name: 'SettingReservationApp',
    components: { LoadingSpinner },
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            fields: [
                'customerReservationCp',
                'customerReservationGr',
                'customerReservationOt',
                'customerCancelCp',
                'customerCancelGr',
                'customerCancelOt',
                'customerPreOtDate',
                'customerPreGrDate',
                'customerPreCpDate',
            ],
            optionsDays: _.range(0, 31).map((v) => String(v)),
            valuesDays: _.range(0, 31).map((v) => String(v)),
            optionsHours: _.range(0, 24).map((v) => String(v)),
            valuesHours: _.range(0, 31).map((v) => String(v)),
            optionsMinutes: _.range(0, 60).map((v) => String(v)),
            valuesMinutes: _.range(0, 60).map((v) => String(v)),
            isLoading: false,
            data: {},
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        setPart(key) {
            if (key === 'customerPreOtDate' || key === 'customerPreGrDate' || key === 'customerPreCpDate') {
                let kstDate;
                if (this.data[key] === 0 || this.data[key] === '0') {
                    kstDate = new Date();
                } else {
                    kstDate = new Date(this.data[key]);
                }
                // 날짜 구성요소 추출
                const year = kstDate.getFullYear();
                const month = String(kstDate.getMonth() + 1).padStart(2, '0');
                const day = String(kstDate.getDate()).padStart(2, '0');
                // 시간 구성요소 추출
                const hour = String(kstDate.getHours()).padStart(2, '0');
                const minute = String(kstDate.getMinutes()).padStart(2, '0');
                // yyyy-mm-dd 형식으로 조합
                const formattedDate = `${year}-${month}-${day}`;
                this.data[`${key}Day`] = formattedDate;
                this.data[`${key}Hour`] = Number(hour.trim() || '0').toString();
                this.data[`${key}Minute`] = Number(minute.trim() || '0').toString();
            } else {
                const matches = [...this.data[key].matchAll(/(\d+)-(\d+)-(\d+)/g)][0] || [];
                this.data[`${key}Day`] = Number(matches[1] || '0').toString();
                this.data[`${key}Hour`] = Number(matches[2] || '0').toString();
                this.data[`${key}Minute`] = Number(matches[3] || '0').toString();
            }
        },
        getPartSum(key) {
            if (key === 'customerPreOtDate' || key === 'customerPreGrDate' || key === 'customerPreCpDate') {
                this.data[key] = `${this.data[`${key}Day`].padStart(2, '0')} ${this.data[`${key}Hour`].padStart(
                    2,
                    '0'
                )}:${this.data[`${key}Minute`].padStart(2, '0')}:00`;

                console.log(this.data[key]);
            } else {
                this.data[key] = `${this.data[`${key}Day`].padStart(2, '0')}-${this.data[`${key}Hour`].padStart(
                    2,
                    '0'
                )}-${this.data[`${key}Minute`].padStart(2, '0')}`;
            }
        },
        validatePreDeadLineReservation() {
            if (this.data.customerPreOtTypeCd === 'U') {
                const currentTime = new Date();
                const preOrderDate = new Date(this.data.customerPreOtDate);
                if (preOrderDate < currentTime) {
                    throw new Error('개인/OT 사전예약은 현재보다 과거의 날짜,시간은 설정 불가능합니다');
                }
            }
            if (this.data.customerPreGrTypeCd === 'U') {
                const currentTime = new Date();
                const preOrderDate = new Date(this.data.customerPreGrDate);
                if (preOrderDate < currentTime) {
                    throw new Error('그룹 사전예약은 현재보다 과거의 날짜,시간은 설정 불가능합니다');
                }
            }
            if (this.data.customerPreCpTypeCd === 'U') {
                const currentTime = new Date();
                const preOrderDate = new Date(this.data.customerPreCpDate);
                if (preOrderDate < currentTime) {
                    throw new Error('쿠폰 사전예약은 현재보다 과거의 날짜,시간은 설정 불가능합니다');
                }
            }
        },
        load() {
            api.get(`/admin/api/center/${this.centerId}/reservation-setting`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data || {};
                    console.log('data');
                    console.log(res.data);
                    _.each(this.data, (i, k) => {
                        if (k.search(/^customer/) >= 0) {
                            this.data[k] = String(i || 0);
                        }
                    });
                    this.fields.forEach((k) => this.setPart(k));
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response && res.response.status != 404) {
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    }
                    console.error(res);
                });
        },
        save() {
            // if (!this.$refs.form.checkValidity() || this.isLoading) {
            //     (this.$refs.form.querySelector(':invalid') || { focus() {} }).focus();
            //     return;
            // }

            const error = false;

            this.fields.forEach((k) => this.getPartSum(k));

            try {
                this.validatePreDeadLineReservation();
            } catch (error) {
                console.error(error.message);
                alert(error);
                return;
            }

            if (error) return;

            this.isLoading = true;
            api.post(`/admin/api/center/${this.centerId}/reservation-setting`, this.data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                    this.load();
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        updateDate(v) {
            this.data.customerPreOtDate = v;
            console.log('Date Updated:', v); // 값 변경 확인
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner-container {
    height: 242px;
}
</style>
